export default __webpack_public_path__ + "static/media/long-right-arrow.8caf043f.png";